import { useQueryClient } from '@tanstack/react-query';
import { serviceServices } from '../services/service.service';

export const usePrefetchServices = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['services', { ...filters, page: String(nextPage) }],
        queryFn: () => serviceServices.getServices({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['services', { ...filters, page: String(prevPage) }],
        queryFn: () => serviceServices.getServices({ ...filters, page: String(prevPage) }),
      });
    }
  };

  const prefetchService = (serviceId) => {
    queryClient.prefetchQuery({
      queryKey: ['service', serviceId],
      queryFn: () => serviceServices.getServiceById(serviceId),
    });
  };

  return { prefetchNextPage, prefetchPrevPage, prefetchService };
};
